<template>

  <div class="user">
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="">
          <el-select v-model="formInline.code" placeholder="广告类型">
            <el-option label="全部" value=""></el-option>
            <el-option label="广告" value="ad"></el-option>
            <el-option label="关键字" value="keyword"></el-option>
            <el-option label="商品排名" value="store"></el-option>
            <el-option label="诚优企业" value="coc"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-input v-model="formInline.name" placeholder="请输入广告名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" class="demo-form-inline">


        <el-form-item >
          <el-button type="primary" icon="el-icon" @click="back">返回上一页</el-button>
        </el-form-item>

        <el-form-item >
          <el-button type="primary" icon="el-icon" @click="flush">刷新</el-button>
        </el-form-item>

      </el-form>
    </div>

    
    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="ad_id" label="广告ID"></el-table-column>
            <el-table-column prop="name" label="广告名称"> </el-table-column>
            <el-table-column prop="price"  label="费用/天"> </el-table-column>
            <el-table-column prop="status_val" label="状态"> </el-table-column> 
            <el-table-column prop="keyword"  label="关键字"> </el-table-column>
            <el-table-column prop="location"  label="广告位置"> </el-table-column>
            <el-table-column prop="index"  label="广告图位置"> </el-table-column>
            <el-table-column prop="code"  label="类型"> 
              <template slot-scope="scope">
                <span v-if="scope.row.code == 'ad'">广告</span>
                <span v-if="scope.row.code == 'keyword'">关键字</span>
                <span v-if="scope.row.code == 'store'">政商企排名</span>
              </template>

            </el-table-column>

            <el-table-column prop="type_val"  label="类型"> </el-table-column>
         
         

            <el-table-column prop="remark"  label="备注"> </el-table-column>

            <el-table-column label="图片" >
                <template slot-scope="scope">
                  <img
                    v-img-url="scope.row.image_url"
                    width="100"
                    height="60"
                  />
                </template>
            </el-table-column>
            <el-table-column prop="ad_status" label="广告图状态"> </el-table-column> 
           
            <el-table-column prop="page_url"  label="跳转页面"> </el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button @click="editClick(scope.row)" type="text" size="small">购买</el-button>

              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

    <Buy :open_add="open_add" v-if="open_add" :add="add"  @close="closeAdd"></Buy>
  </div>
</template>

<script>
import AdApi from '@/api/ad.js';
import Buy from "./buyAd.vue";
export default {
  components: {
    Buy
  },
  inject: ['reload'],
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索表单对象*/
      form: {},
      /*是否打开添加弹窗*/
      open_add: false,
      add:{},
      /*是否打开编辑弹窗*/
      open_edit: false,
      formInline: {
        code:"",
        name:""
      },
      status: ['未开始', '进行中', '已结束']
    };
  },
  created() {

    /*获取列表*/
    this.getTableList();
  },
  methods: {
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    flush(){
      this.getTableList();
    },
    back(){
      this.$router.push({
        path: '/plus/ad/index',
      });
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = this.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;
      AdApi.isBuyRecordList(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {});
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },

    async editClick(row) {
      var self = this;
      this.add = {
        ad_id: row.ad_id,
        index: row.index,
        code:row.code
      }
      self.open_add = true;
     
    },
  }
};
</script>

<style>
.w150{
    border: 1px solid #eee;
  }
  .tc{
    border: 1px solid #eee;
  }
</style>



// WEBPACK FOOTER //
// src/views/plus/ad/ad/isbuyrecordlist.vue